
import { defineComponent, PropType } from 'vue'
export default defineComponent({
  name: 'AlertHasDiscount',

  props: {
    hasDiscount: {
      type: Boolean as PropType<boolean>,
      required: true,
      default: false
    }
  }
})
